import React, { FunctionComponent, useEffect, useRef } from "react";
import { useMenu } from "../useMenu";
import styles from "./Hamburger.module.scss";

export const HamburgerComponent: FunctionComponent = (): React.JSX.Element => {
  const { isHamburgerOpen, onHamburgerToggled } = useMenu();
  const hamburgerRef = useRef<HTMLDivElement | null>(null);

  useEffect((): void => {
    if (isHamburgerOpen) {
      document.body.classList.add(styles["fixed"] as string);
    } else {
      document.body.classList.remove(styles["fixed"] as string);
    }
  }, [isHamburgerOpen]);

  const hamburgerSize = "0 0 21 3";
  const hamburgerLine =
    "M3,0H6L3,3H0zM8,0H11L8,3H5zM13,0H16L13,3H10zM18,0H21L18,3H15z";

  return (
    <div
      className={[
        styles["hamburger"],
        isHamburgerOpen ? styles["animate"] : "",
      ].join(" ")}
      ref={hamburgerRef}
      onClick={onHamburgerToggled}
      onKeyPress={onHamburgerToggled}
      role="button"
      aria-label="Toggle menu"
      tabIndex={0}>
      <div className={styles["bar"]}>
        <svg viewBox={hamburgerSize}>
          <path d={hamburgerLine} />
        </svg>
      </div>
      <div className={styles["bar"]}>
        <svg viewBox={hamburgerSize}>
          <path d={hamburgerLine} />
        </svg>
      </div>
      <div className={styles["bar"]}>
        <svg viewBox={hamburgerSize}>
          <path d={hamburgerLine} />
        </svg>
      </div>
    </div>
  );
};
